import React from 'react';
import { useIntl } from 'react-intl';
import { Badge } from './Badge.esm.js';

var BetaBadge = function (_a) {
    var dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId;
    var intl = useIntl();
    return (React.createElement(Badge, { dataMetrics: dataMetrics, dataTestId: dataTestId || "badge-beta", appearance: "green" }, intl.formatMessage({ id: "1SPX7G", defaultMessage: [{ type: 0, value: "Beta" }] })));
};

export { BetaBadge };
//# sourceMappingURL=BetaBadge.esm.js.map
